<template>
	<v-app class="ms-app" :class="{ 'no-navigation': isCollapsed, dark: false, light: true }">
		<http-loader />

		<router-view
			v-slot="{ Component }"
			:france-connect-logout-redirect-uri="snapshot.context.franceConnectLogoutRedirectUri"
			name="appbar"
			:send="send"
			:user-profile="snapshot.context.userProfile"
		>
			<component :is="Component" :user-profile="snapshot.context.userProfile" />
		</router-view>

		<router-view :app-version="snapshot.context.version" name="nav" />

		<v-main class="ms-app-main">
			<router-view v-slot="{ Component }">
				<component :is="Component" :user-profile="snapshot.context.userProfile" />
			</router-view>
		</v-main>

		<mobile-app-banner v-if="isAndroidOrIosDevice" />

		<!-- Version display -->
		<div class="app-version">v{{ appVersion }}</div>
	</v-app>
</template>

<script lang="ts" setup>
import { useMachine } from '@xstate/vue';
import { watch } from 'vue';
import { VApp, VMain } from 'vuetify/components';

// TODO: rollback this once we have a way to handle both themes
//import { useTheme } from '@silae/composables';
import { appMachine } from '~/_v3/app/machines/app.machine';
import { token } from '~/_v3/composables/useToken';
import { HttpLoader } from '~/components';
import { isCollapsed } from '~/composables';
import { Devices } from '~/plugins';

import { MobileAppBanner } from './_v3/common/ui/components';
import { initLocale, initThemeSync, initUserTracking } from './app.init';
import { initStonly } from './plugins/banner';
import { initChatbot } from './plugins/chatbot';

const { snapshot, send } = useMachine(appMachine);

const isAndroidOrIosDevice = Devices().isIOS || Devices().isAndroid;

// Access the version from Vite's global constant
const appVersion = __APP_VERSION__ || 'unknown';

watch(token, newToken => {
	if (newToken) {
		send({ type: 'LOAD_PROFILE' });
	}
});

const refreshToken = () => {
	send({ type: 'REFRESH_TOKEN' });
	setTimeout(refreshToken, 55 * 60 * 1000); // 55 minutes in milliseconds
};

initLocale();
initUserTracking();
initThemeSync();
refreshToken();
initChatbot();
initStonly();

// TODO: rollback this once we have a way to handle both themes
//const { isDark } = useTheme();
</script>

<style lang="scss" scoped>
.app-version {
	display: none;
}
.ms-app {
	background-color: var(--sk-background-hex);
	transition: background var(--sk-transition);
	overflow-x: hidden;

	&-main {
		position: relative;
		display: flex;
		flex-direction: column;
		min-height: calc(100vh - var(--sk-app-bar-height));
		max-height: 100vh;
	}
}
</style>
